import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '予約一覧',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 0,
  staffOnly: true,
};
